import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      columns: _ctx.tabelParams.columnsTable,
      endpoint: _ctx.tabelParams.endpoint,
      headerTitle: _ctx.tabelParams.headerTitle,
      buttonTitle: _ctx.tabelParams.buttonTitle,
      editTitle: _ctx.tabelParams.editTitle,
      deleteTitle: _ctx.tabelParams.deleteTitle,
      showColumnActivate: false,
      confirmDialogDelete: _ctx.tabelParams.confirmDialogDelete,
      failedToast: _ctx.onDeleteFailedMessage
    }, {
      form: _withCtx(() => [
        _createVNode(_component_Form)
      ]),
      reminderDaysBeforeExpiry: _withCtx(({slotProps}) => [
        _createTextVNode(_toDisplayString(`${slotProps.data.reminderDaysBeforeExpiry ?? 0} hari`), 1)
      ]),
      _: 1
    }, 8, ["columns", "endpoint", "headerTitle", "buttonTitle", "editTitle", "deleteTitle", "confirmDialogDelete", "failedToast"])
  ]))
}